<template>
  <div class="layout-slide-menu">
    <el-menu router :collapse="isCollapse" :default-active="$route.path">
      <template v-for="(menu, index) in menuList">
        <template v-if="hasPermission(menu.permission)">
          <el-menu-item
            v-if="!menu.children || menu.children.length == 0"
            :index="menu.path"
            :route="menu.path"
            :key="index"
          >
            <i v-if="menu.icon" :class="menu.icon"></i>
            <span slot="title">{{ menu.title }}</span>
          </el-menu-item>
          <el-submenu v-else :index="menu.path" :key="menu.path">
            <template slot="title">
              <i v-if="menu.icon" :class="menu.icon"></i>
              <span slot="title">{{ menu.title }}</span>
            </template>
            <template v-for="(menu2, index) in menu.children">
              <template v-if="hasPermission(menu2.permission)">
                <el-menu-item
                  :index="menu2.path"
                  :route="menu2.path"
                  :key="menu2.path"
                  v-if="menu2.show"
                >
                  <i v-if="menu2.icon" :class="menu2.icon"></i>
                  <span slot="title">{{ menu2.title }}</span>
                </el-menu-item>
              </template>
            </template>
          </el-submenu>
        </template>
      </template>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: "SlideMenu",
  data() {
    return {
      menuList: []
    };
  },
  props: ["isCollapse"],
  created() {
    const data = [];
    const routes = this.$router.options.routes;
    for (var i = 0; i < routes.length; i++) {
      const route = routes[i];
      const path = route.path;
      if (
        path == "/bigScreen" ||
        path == "/" ||
        path == "/Welcome" ||
        path == "/realData" ||
        path == "/realtimeQuery"
      ) {
        continue;
      }
      const rootId = i;
      let rootPath = route.path;
      let rootMeta = route.meta;
      const children = route.children;
      let hasChildren = true;

      if (children && children.length == 1) {
        rootPath += "/" + children[0].path;
        rootMeta = children[0].meta;
        hasChildren = false;
      }
      const rootTitle = rootMeta.title;
      const rootPermission = rootMeta.permission;
      const rootIcon = rootMeta.icon;
      const rootShow = rootMeta.show;

      const rootMenu = {
        id: rootId,
        title: rootTitle,
        permission: rootPermission,
        path: rootPath,
        icon: rootIcon,
        show: rootShow,
        children: []
      };
      data.push(rootMenu);
      if (!hasChildren) {
        continue;
      }
      for (var j = 0; j < children.length; j++) {
        const cId = i + "-" + j;
        const cRoute = children[j];
        let cPath = rootPath + "/" + cRoute.path;
        let cMeta = cRoute.meta;
        const cTitle = cMeta.title;
        const cPermission = cMeta.permission;
        const cIcon = cMeta.icon;
        const cShow = cMeta.show;
        const cMenu = {
          id: cId,
          title: cTitle,
          permission: cPermission,
          path: cPath,
          icon: cIcon,
          show: cShow
        };
        rootMenu.children.push(cMenu);
      }
    }
    this.menuList = data;
  },
  methods: {
    hasPermission(permission) {
      let flag = false;
      const menus = this.$store.state.login.menu;
      if (!menus) {
        return false;
      }
      for (let i = 0; i < menus.length; i++) {
        const menu = menus[i];
        if (menu == permission) {
          flag = true;

          break;
        }
      }
      return flag;
    }
  },
  mounted() {}
};
</script>

<style lang="less">
@import "./SlideMenu.less";
</style>



// WEBPACK FOOTER //
// src/components/SlideMenu.vue